
import { Product } from '@/types';

interface DatabaseProduct {
  id: string;
  name: string;
  image_path: string[] | null;
  description: string[] | null;
  ip_address: string;
  primary_email: string | null;
  secondary_emails: string | null;
  license_start_date: string;
  expiration_date: string;
  status: string;
  created_by: string | null;
  created_at: string;
}

export const mapDatabaseProductToProduct = (dbProduct: DatabaseProduct): Product => {
  return {
    id: dbProduct.id,
    name: dbProduct.name,
    imagePath: Array.isArray(dbProduct.image_path) ? dbProduct.image_path.join(',') : (dbProduct.image_path || ''),
    description: Array.isArray(dbProduct.description) ? dbProduct.description.join(',') : (dbProduct.description || ''),
    ipAddress: dbProduct.ip_address,
    primaryEmail: dbProduct.primary_email || '',
    secondaryEmails: dbProduct.secondary_emails || '',
    licenseStartDate: dbProduct.license_start_date,
    expirationDate: dbProduct.expiration_date,
    status: dbProduct.status as 'active' | 'expired',
    createdBy: dbProduct.created_by || '',
    createdAt: dbProduct.created_at,
  };
};

export const prepareProductForInsert = (product: Omit<Product, "id" | "status" | "createdAt" | "createdBy">, userId: string | null) => {
  return {
    name: product.name,
    image_path: product.imagePath ? product.imagePath.split(',').filter(Boolean) : [],
    description: product.description ? [product.description] : [],
    ip_address: product.ipAddress,
    primary_email: product.primaryEmail || null,
    secondary_emails: product.secondaryEmails || null,
    license_start_date: product.licenseStartDate,
    expiration_date: product.expirationDate,
    created_by: userId,
  };
};

export const prepareProductForUpdate = (product: Product) => {
  return {
    name: product.name,
    image_path: product.imagePath ? product.imagePath.split(',').filter(Boolean) : [],
    description: product.description ? [product.description] : [],
    ip_address: product.ipAddress,
    primary_email: product.primaryEmail || null,
    secondary_emails: product.secondaryEmails || null,
    license_start_date: product.licenseStartDate,
    expiration_date: product.expirationDate,
    updated_at: new Date().toISOString(),
  };
};
